import Vue from 'vue/dist/vue.min.js';
import Vuex from 'vuex';
import axios from 'axios';
import {getCookieValue} from './misc.js';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        pageTitle: '',
        isMobile: null, //is viewport < 835px
        isSmallMobile: null, //is viewport < 650px
        isMdDesktop: null, //is viewport < 1024px
        pageAnchors: [],
        showInlineAnchors: false,
        units: null,
        menuKeys: [],
        favorites: { //NOTE: all ids stored as strings
            documentId: [],
            softwareId: [],
            articleId: [],
            productId: [],
            legalDocumentId: []
        },
        currentLang: null,
        litOrderCart: [],
        GAID: null 
    },

    mutations:  {
        updateTitle(state, title) {
            state.pageTitle = title;
        },
        setMobileState(state, mobileState) {
            state.isMobile = mobileState;
        },
        setSmallMobileState(state, mobileState) {
            state.isSmallMobile = mobileState;
        },
        setMdDesktopState(state, mobileState) {
            state.isMdDesktop = mobileState;
        },
        setPageAnchors(state, anchors) {
            state.pageAnchors = anchors;
        },
        setAnchorDropdownVis(state, anchorState) {
            state.showInlineAnchors = anchorState;
        },
        setUnits(state, units) {
            if (units) {
                state.units = units;
            } else {
                state.units = 
                     state.units == 'us' ? 'metric'
                    : state.units == 'metric' ? 'us'
                    : null;
            }
        },
        updateMenu(state, obj) {
            state.menuKeys.push(obj);
        },
        updateFavorites(state, data) {
            // add/remove items from stores favorites
            if (data.action == "add") {
                // console.log("add");
                state.favorites[data.type].push(data.id);
            } else if (data.action == "remove") {
                // console.log("remove");

                if (state.favorites[data.type].includes(data.id)) {
                    state.favorites[data.type].splice(state.favorites[data.type].indexOf(data.id), 1);
                }
            } else {
                return;
            }
        },
        initFavorites(state, data) {
            state.favorites[data.type] = data.arr;
        },
        sanitizeFavorites(state, results) {
            // sanitisze favorites based on valid favs returned from api
            state.favorites.documentId = results.documentIds.map(i => `${i}`);
            state.favorites.softwareId = results.softwareIds.map(i => `${i}`);
            state.favorites.articleId = results.articleIds.map(i => `${i}`);
            state.favorites.productId = results.productIds.map(i => `${i}`);
            state.favorites.legalDocumentId = results.legalDocumentIds.map(i => `${i}`);
        },
        setCurrentLang(state, lang) {
            state.currentLang = lang;
        },
        updateLitOrderCart(state, data) {
            state.litOrderCart = data;
        },
        setGAID(state, id) {
            state.GAID = id;
        }
    },
    actions: {
        checkMobile(context) {
            var mqlMd = window.matchMedia('(max-width: 835px)');
            var mqlSm = window.matchMedia('(max-width: 650px)');
            var mqlMdDesktop = window.matchMedia('(max-width: 1024px)');

            // console.log(mqlMd.matches);
            var isMobile = mqlMd.matches ? true : false;
            context.commit('setMobileState', isMobile);

            mqlMd.addEventListener('change',() => {
                isMobile = mqlMd.matches ? true : false;
                context.commit('setMobileState', isMobile);
            });

            var isSmallMobile = mqlSm.matches ? true : false;
            context.commit('setSmallMobileState', isSmallMobile);

            mqlSm.addEventListener('change',() => {
                isSmallMobile = mqlSm.matches ? true : false;
                context.commit('setSmallMobileState', isSmallMobile);
            });

            var isMdDesktop = mqlMdDesktop.matches ? true : false;
            context.commit('setMdDesktopState', isMdDesktop);

            mqlMdDesktop.addEventListener('change',() => {
                isMdDesktop = mqlMdDesktop.matches ? true : false;
                context.commit('setMdDesktopState', isMdDesktop);
            });
        },
        initCookies(context) {
            // check for current cookies
            context.commit('initFavorites', {"type":'documentId', arr: getCookieValue('documentIds').split(',')} );
            context.commit('initFavorites', {"type":'softwareId', arr: getCookieValue('softwareIds').split(',')} );
            context.commit('initFavorites', {"type":'articleId', arr: getCookieValue('articleIds').split(',')} );
            context.commit('initFavorites', {"type":'productId', arr: getCookieValue('productIds').split(',')} );
            context.commit('initFavorites', {"type":'legalDocumentId', arr: getCookieValue('legalDocumentIds').split(',')} );

            // console.log(context.state.favorites);

            context.dispatch('checkFavorites');
        },
        cookieFavorites(context) {
            // cookie current saved items in store
            let docStr = context.state.favorites.documentId.toString();
            let softwareStr = context.state.favorites.softwareId.toString();
            let articleStr = context.state.favorites.articleId.toString();
            let productStr = context.state.favorites.productId.toString();
            let legalDocStr = context.state.favorites.legalDocumentId.toString();
            document.cookie = `documentIds=${docStr}; max-age=1209600; path=/`;
            document.cookie = `softwareIds=${softwareStr}; max-age=1209600; path=/`;
            document.cookie = `articleIds=${articleStr}; max-age=1209600; path=/`;
            document.cookie = `productIds=${productStr}; max-age=1209600; path=/`;
            document.cookie = `legalDocumentIds=${legalDocStr}; max-age=1209600; path=/`;
        },
        checkFavorites(context) {
            // validate cookies with api
            let docStr = context.state.favorites.documentId.toString();
            let softwareStr = context.state.favorites.softwareId.toString();
            let articleStr = context.state.favorites.articleId.toString();
            let productStr = context.state.favorites.productId.toString();
            let legalDocStr = context.state.favorites.legalDocumentId.toString();

            let axiosParams = {
                documentId: docStr == "" ? null : docStr.charAt(0) == "," ? docStr.slice(1) : docStr,
                softwareId: softwareStr == "" ? null : softwareStr.charAt(0) == "," ? softwareStr.slice(1) : softwareStr,
                articleId: articleStr == "" ? null : articleStr.charAt(0) == "," ? articleStr.slice(1) : articleStr,
                productId: productStr == "" ? null : productStr.charAt(0) == "," ? productStr.slice(1) : productStr,
                legalDocumentId: legalDocStr == "" ? null : legalDocStr.charAt(0) == "," ? legalDocStr.slice(1) : legalDocStr
            }
            // console.log(axiosParams);

            // const apiUrl = getApiUrl();
            const apiUrl = `/api/validateids?`;
            // console.log(apiUrl);
            // let TESTURL = "http://localhost:3003/validateIds";
            axios.get(apiUrl, {
                params: {
                    ...axiosParams
                }
            })
            .then(function(response) {
                store.commit('sanitizeFavorites', response.data.results);
                store.dispatch('cookieFavorites');
            })
            .catch(function(error) {
                console.log(error);
            });
        },
        initUnits(context) {
            let lang = document.querySelector('.top-bar__subnav-link.active') ? document.querySelector('.top-bar__subnav-link.active').dataset.lang : null;
            // console.log("LANG", lang)
            store.commit('setCurrentLang', lang);
            if (lang !== "en-us") {
                store.commit('setUnits', 'metric');
            } else {
                store.commit('setUnits', 'us');
            }
        },
        initGAID(context) {
            let id = getCookieValue('_ga') == '' ? null : getCookieValue('_ga') ;
            store.commit('setGAID', id);
            // console.log(id);
        }
    }
});

export default store;